import { Link } from "react-router-dom";

export const LegalFooter = () => (
  <footer className="mt-auto py-6 text-center" data-testid="public-footer">
    <Link
      to="/mentions-legales"
      data-testid="footer-legal-link"
      className="text-xs text-slate-300/80 hover:text-white underline underline-offset-2 transition-colors"
    >
      Mentions légales
    </Link>
  </footer>
);

export default LegalFooter;
